import React from 'react';
import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';

import SearchIcon from '../Icons/SearchIcon';
import InputText from './InputText';

const Container = styled.div`
  position: relative;
  width: 100%;

  input {
    padding-left: 2rem;
  }

  svg {
    position: absolute;
    top: 13px;
    left: 0;
    margin-left: 0.5rem;
  }
`;

const SearchField = (props) => (
  <Container>
    <SearchIcon color={themeColors.colorTextSecondary} />
    <InputText {...props} />
  </Container>
);

SearchField.propTypes = {};

export default SearchField;
